import * as types from '../actiontypes';
import Env from '../../util/env';
import {serviceURL} from '../../util/uiconstants';

export function getProjectEngUsers(projectId) {
	let url = `${Env.getBaseURL(serviceURL)}Projects/${projectId}/engagementusers`;
	return {
		type: types.GET_ENGAGEMENT_CONTACT_DETAILS,
		meta: {
			api: {
				url: url,
				method: 'GET'
			}
		}
	};
}

export function clearProjectEngUsers(){
    return {
        type: types.CLEAR_ENGAGEMENT_CONTAC_DETAILS,
    }
}